<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>

    <!-- Modal de suscripción expirada -->
    <SubscriptionExpiredModal
      :isVisible="showSubscriptionModal"
      @confirm="handleSubscriptionConfirm"
      @cancel="handleSubscriptionCancel"
    />

    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
      />
    </div>
    <!-- Mapa -->
    <div class="hidden mt-10">
      <div class="flex flex-1">
        <fwb-heading tag="h2">
          Propiedad
        </fwb-heading>
      </div>
      <div class="flex flex-1 justify-end items-end">
        <fwb-breadcrumb>
          <fwb-breadcrumb-item href="/properties">
            Lista de propiedades
          </fwb-breadcrumb-item>

          <fwb-breadcrumb-item> Agregar nuevo inmueble </fwb-breadcrumb-item>
        </fwb-breadcrumb>
      </div>
    </div>
    <!-- Mapa -->
     
    <!-- Header con botones -->
    <div class="hidden sm:flex justify-end items-center mb-4 mt-5 sm:mt-4">
      <div class="flex gap-3">
        <button 
          @click="handleExit"
          class="px-4 py-2 text-sm text-gray-800 border border-gray-200 bg-white hover:bg-gray-100 hover:text-tuin-100 rounded-lg font-medium transition-colors"
        >
          Salir
        </button>
        <button 
          class="px-4 py-2 text-sm text-white bg-tuin-100 hover:bg-tuin_hover rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="!complete_property || is_available || shouldBlockBySubscription"
          @click="changeStatus" 
        >
          {{ is_available ? 'Publicado' : 'Publicar' }}
        </button>
      </div>
    </div>

    <!-- Layout principal con dos columnas -->
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
      
      <!--Steps (columna izquierda)-->
      <div class="lg:col-span-4 xl:col-span-3 sm:mt-16 ml-4">
        <div class="hidden sm:block sticky top-6">      
          <ol class="relative text-gray-500 border-s border-gray-da">                  
              <li 
                class="mb-10 ms-6 flex items-center cursor-pointer" 
                @click="navigateToStep(0)"
              >            
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[0] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[0] ? 'text-tuin-100' : 'text-gray-500'">Información general</h3>
              </li>
              <li 
                class="mb-10 ms-6 flex items-center"
                :class="!stepValidations[0] ? '' : 'cursor-pointer'"
                @click="navigateToStep(1)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[1] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[1] ? 'text-tuin-100' : 'text-gray-500'">Precio</h3>
              </li>
              <li 
                class="mb-10 ms-6 flex items-center"
                :class="!stepValidations[1] ? '' : 'cursor-pointer'"
                @click="navigateToStep(2)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[2] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[2] ? 'text-tuin-100' : 'text-gray-500'">Ubicación</h3>
              </li>
              <li 
                class="mb-10 ms-6 flex items-center"
                :class="!stepValidations[2] ? '' : 'cursor-pointer'"
                @click="navigateToStep(3)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[3] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[3] ? 'text-tuin-100' : 'text-gray-500'">Características</h3>
              </li>
              <li 
                class="mb-10 ms-6 flex items-center"
                :class="!stepValidations[3] ? '' : 'cursor-pointer'"
                @click="navigateToStep(4)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[4] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[4] ? 'text-tuin-100' : 'text-gray-500'">Detalles adicionales</h3>
              </li>
              <li 
                class="mb-10 ms-6 flex items-center"
                :class="!stepValidations[4] ? '' : 'cursor-pointer'"
                @click="navigateToStep(5)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[5] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[5] ? 'text-tuin-100' : 'text-gray-500'">Media</h3>
              </li>
              <li 
                class="mb-10 ms-6 flex items-center"
                :class="!stepValidations[5] ? '' : 'cursor-pointer'"
                @click="navigateToStep(6)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[6] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[6] ? 'text-tuin-100' : 'text-gray-500'">Título</h3>
              </li>
              <li 
                class="ms-6 flex items-center"
                :class="!stepValidations[6] ? '' : 'cursor-pointer'"
                @click="navigateToStep(7)"
              >
                  <span class="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4" :class="stepValidations[7] ? 'bg-tuin-100' : 'bg-gray-da'">
                      <svg class="w-3.5 h-3.5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
                      </svg>
                  </span>
                  <h3 class="font-medium leading-tight" :class="stepValidations[7] ? 'text-tuin-100' : 'text-gray-500'">Descripción</h3>
              </li>
          </ol>
        </div>
      </div>

      <!-- Contenido principal (columna derecha) -->
      <div class="lg:col-span-8 xl:col-span-9">
        <!-- Step back button -->
        <div class="flex justify-between mb-2 sm:mb-0">
          <button 
            v-if="currentStep > 0"
            class="py-2.5 px-2.5 rounded-full"
            @click="previousStep"
            :disabled="currentStep === 0"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18" fill="none">
              <path d="M9.93061 17.1115C9.63057 17.4115 9.22368 17.58 8.79941 17.58C8.37515 17.58 7.96826 17.4115 7.66821 17.1115L0.468214 9.9115C0.168261 9.61145 -0.000244141 9.20456 -0.000244141 8.7803C-0.000244141 8.35604 0.168261 7.94914 0.468214 7.6491L7.66821 0.449099C7.96998 0.157644 8.37414 -0.00362587 8.79366 1.90735e-05C9.21317 0.00366592 9.61447 0.171934 9.91112 0.468588C10.2078 0.765242 10.376 1.16654 10.3797 1.58606C10.3833 2.00557 10.2221 2.40973 9.93061 2.7115L5.59941 7.1803L20.7994 7.1803C21.2238 7.1803 21.6307 7.34887 21.9308 7.64893C22.2308 7.94899 22.3994 8.35595 22.3994 8.7803C22.3994 9.20464 22.2308 9.61161 21.9308 9.91167C21.6307 10.2117 21.2238 10.3803 20.7994 10.3803L5.59941 10.3803L9.93061 14.8491C10.2306 15.1491 10.3991 15.556 10.3991 15.9803C10.3991 16.4046 10.2306 16.8115 9.93061 17.1115Z" fill="black"/>
            </svg>
          </button>
          <div v-else></div> <!-- Espacio vacío cuando no hay botón de retroceso -->
          <button 
            class="sm:hidden px-4 py-2 text-sm text-white bg-tuin-100 hover:bg-tuin_hover rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="!complete_property || is_available || shouldBlockBySubscription"
            @click="changeStatus" 
          >
            {{ is_available ? 'Publicado' : 'Publicar' }}
          </button>
        </div>

        <!-- Progress Bar Component -->
        <ProgressBar
          :current="Object.values(stepValidations).filter(Boolean).length"
          :total="steps.length"
          variant="default"
          size="medium"
          :show-header="true"
          :show-counter="true"
          @progress-change="onProgressChange"
          @complete="onProgressComplete"
        />

        <!-- New design Steps-->
        <div class="space-y-6 sm:w-fit sm:max-w-full">
          <!-- Step content based on currentStep -->
          <div v-if="currentStep === 0">
            <FormGeneralComponent 
              ref="formGeneralRef"
              :resp="propertyData.general" 
              :property-id="id"
              :is-available="is_available"
              @trigger-update="updateProperty"  
            />
          </div>

          <div v-if="currentStep === 1">
            <FormPriceComponent  
              ref="formPriceRef"
              :resp="propertyData" 
              :property-id="id"
              :is-available="is_available"
              @trigger-update="updateProperty"  
            />
          </div>

          <div v-if="currentStep === 2">
            <FormLocationComponent  
              ref="formLocationRef"
              :resp="propertyData" 
              :property-id="id"
              :is-available="is_available"
              @trigger-update="updateProperty"  
            />
          </div>

          <div v-if="currentStep === 3">
            <FormCharactersComponent  
              ref="formCharactersRef"
              :resp="propertyData" 
              :property-id="id"
              :is-available="is_available"
              @trigger-update="updateProperty"  
            />
          </div>

          <div v-if="currentStep === 4">
            <AccordionDetailsComponent 
              ref="accordionDetailsRef"
              :property-id="id"
              @trigger-update="updateProperty"  
            />
          </div>

          <div v-if="currentStep === 5">
            <FormMediaComponent 
              ref="formMediaRef"
              :property-id="id"
              @trigger-update="updateProperty"  
            />
          </div>

          <div v-if="currentStep === 6">
            <FormTittle
              ref="formTittleRef"
              :property-id="id" 
              @title-saved="onTitleSaved"
              @trigger-update="updateProperty" 
            />
          </div>

          <div v-if="currentStep === 7">
            <FormDescription
              ref="formDescriptionRef"
              :property-id="id" 
              @description-saved="onDescriptionSaved"
              @trigger-update="updateProperty" 
            />
          </div>

          <div class="sm:flex hidden justify-end">
            <!-- Botón Mapa: solo visible en step 2 mientras no se haya abierto -->
            <button
              v-if="currentStep === 2 && !mapOpened"
              @click="handleOpenMap"
              :disabled="!isLocationActive"
              class="w-full font-medium sm:w-auto px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Mapa
            </button>
              
            <!-- Botón Siguiente: visible cuando NO estamos en step 2, o cuando estamos en step 2 Y se abrió el mapa -->
            <button
              v-if="currentStep !== 2 || (currentStep === 2 && mapOpened)"
              @click="nextStep"
              :disabled="currentStep === steps.length || isSaving"
              class="w-full sm:w-auto px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium"
              >
                Siguiente
            </button>
          </div>

          <!-- Navigation buttons -->
          <div 
            class="sm:hidden fixed bottom-0 left-0 right-0 z-9 bg-[#F9F9F9] flex justify-between items-center gap-3 p-[11px]"
            :style="{ paddingLeft: 'max(env(safe-area-inset-left), 11px)', paddingRight: 'max(env(safe-area-inset-right), 11px)', paddingBottom: 'max(env(safe-area-inset-bottom), 11px)' }"
          >
            <!-- Left side - Salir button -->
            <div class="w-1/2">
              <button 
                @click="handleExit"
                class="w-full px-5 py-2.5 text-sm text-gray-800 border border-gray-200 bg-white hover:bg-gray-100 hover:text-tuin-100 rounded-lg font-medium transition-colors"
              >
                Salir
              </button>
            </div>

            <!-- Right side - Navigation buttons -->
            <div class="w-1/2">
              <!-- Botón Mapa: solo visible en step 2 mientras no se haya abierto -->
              <button
                v-if="currentStep === 2 && !mapOpened"
                @click="handleOpenMap"
                :disabled="!isLocationActive"
                class="w-full px-5 py-2.5 text-sm bg-tuin-100 font-medium text-white rounded-lg hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                Mapa
              </button>
              
              <!-- Botón Siguiente: visible cuando NO estamos en step 2, o cuando estamos en step 2 Y se abrió el mapa -->
              <button
                v-if="currentStep !== 2 || (currentStep === 2 && mapOpened)"
                @click="nextStep"
                :disabled="currentStep === steps.length || isSaving"
                class="w-full px-5 py-2.5 text-sm bg-tuin-100 font-medium text-white rounded-lg hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>

        <!-- Old design -->
        <!--
        <div
          class="w-[]"      
        >
          <fwb-tabs
            v-model="activeTab"
            class="p-5"
          >
            <fwb-tab
              name="first"
              title="Datos generales"
            >
              <p class="hidden text-sm font-normal leading-6 text-black "> 
                Por favor, completa todos los campos obligatorios marcados con un asterisco (*). 
                La información precisa y detallada ayudará a que tu inmueble destaque en el mercado. 
              </p>
              <div v-for="(partner, index) in groupedPartners" :key="index" class="mb-4">
                <p class="text-sm font-normal leading-6 text-black">
                  Consulta tu propiedad publicada en 
                  <strong>{{ partner.partner === 'EasyAviso' ? 'Pincali' : partner.partner }}</strong>:
                </p>
                <p v-if="partner.sale" class="text-sm font-normal leading-6 text-black">
                  🏷️ En venta: <a :href="partner.sale" target="_blank" class="text-blue-500">aquí</a>
                </p>
                <p v-if="partner.rent" class="text-sm font-normal leading-6 text-black">
                  📃 En renta: <a :href="partner.rent" target="_blank" class="text-blue-500">aquí</a>
                </p>
              </div>

              <FormComponent 
                :property-id="id" 
                @trigger-update-property="updateProperty" 
              />        
            </fwb-tab>

            <fwb-tab 
              name="media" 
              title="Media" 
              :disabled="!active_tab"
            >
              <FormMediaComponent 
                :property-id="id" 
              />
            </fwb-tab>

            <fwb-tab 
              name="details" 
              title="Detalles adicionales" 
              :disabled="!active_tab"
            >
              <AccordionDetailsComponent 
                :property-id="id" 
              />
            </fwb-tab>

            <fwb-tab 
              name="tittle" 
              title="Titulo" 
              :disabled="!active_tab"
            >
              <FormTittle
                :property-id="id" 
              /> 
            </fwb-tab>

            <fwb-tab 
              name="description" 
              title="Descripcion" 
              :disabled="!active_tab"
            >
              <FormDescription
                :property-id="id" 
              /> 
            </fwb-tab>
          </fwb-tabs>
        </div>
        -->
      </div>
      </div>
    </div>
    <!-- Mobile floating buttons -->
    
    <!-- Modals -->
    <ExitModal 
      :is-visible="showExitModal"
      @confirm="handleExitConfirm"
      @cancel="handleModalCancel"
    />
    
    <DraftModal 
      :is-visible="showDraftModal"
      @confirm="handleDraftConfirm"
      @cancel="handleModalCancel"
    />
    
    <PublishOrIAModal 
      :is-visible="showPublishOrIAModal"
      :is-blocked-by-subscription="shouldBlockBySubscription"
      @publish="handlePublishFromModal"
      @confirm="handleOptimizeWithIA"
      @cancel="handleModalCancel"
    />
    
    <TitleModal 
      :is-visible="showTitleModal"
      :is-blocked-by-subscription="shouldBlockBySubscription"
      @publish="handlePublishFromTitleModal"
      @confirm="handleOptimizeDescriptionWithIA"
      @cancel="handleModalCancel"
    />
  </div>
</template>
<script setup>
import AccordionDetailsComponent from "@/components/properties/AccordionDetailsComponent.vue";
import FormGeneralComponent from "@/components/properties/FormGeneralComponent.vue";
import FormPriceComponent from "@/components/properties/FormPriceComponent.vue";
import FormLocationComponent from "@/components/properties/FormLocationComponent.vue";
import FormCharactersComponent from "@/components/properties/FormCharactersComponent.vue";
import FormMediaComponent from "@/components/properties/FormMediaComponent.vue";
import FormTittle from "@/components/properties/FormTittle.vue";
import FormDescription from "@/components/properties/FormDescription.vue";
import ExitModal from "@/components/properties/modal/ExitModal.vue";
import DraftModal from "@/components/properties/modal/DraftModal.vue";
import PublishOrIAModal from "@/components/properties/modal/PublishOrIAModal.vue";
import TitleModal from "@/components/properties/modal/TitleModal.vue";
import ProgressBar from "@/components/common/ProgressBar.vue";
import LoaderTuin from "@/commond/LoaderTuin.vue";
import ToastAlert from "@/commond/ToastAlert.vue";

import axios from "axios";

import {
  FwbBreadcrumb,
  FwbBreadcrumbItem,
  FwbHeading
} from "flowbite-vue";
import { ref, onMounted, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import SubscriptionExpiredModal from '@/components/properties/modal/SubscriptionExpiredModal.vue';

let store = useStore();
let session = computed(() => store.getters.getUserSession);

// Template refs para componentes hijos
const formGeneralRef = ref(null);
const formPriceRef = ref(null);
const formLocationRef = ref(null);
const formCharactersRef = ref(null);
const accordionDetailsRef = ref(null);
const formMediaRef = ref(null);
const formTittleRef = ref(null);
const formDescriptionRef = ref(null);

// Acceder al parámetro 'id' de la URL directamente
const route = useRoute();
let id = route.params.id;
let active_tab = ref(false);
const groupedPartners = ref([]);
//const activeTab = ref("first");
let propertyData = ref({});
let type_movent = ref("");
const is_available = ref(false);
let router = useRouter();
let loader = ref(false);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
let subscriptionStatus = ref('');

// Modal states
const showExitModal = ref(false);
const showDraftModal = ref(false);
const showPublishOrIAModal = ref(false);
const showTitleModal = ref(false);
const showSubscriptionModal = ref(false);

// Multi-step form variables
const currentStep = ref(0);
const isSaving = ref(false);
const mapOpened = ref(false);
const steps = [
  'Información general',
  'Precio', 
  'Ubicación',
  'Características',
  'Detalles adicionales',
  'Media',
  'Título',
  'Descripción'
];

//Limite de propiedades
const currentPlanId = ref(null);  
const propertyLimit = ref(Infinity);  
//const showLimitModal = ref(false);  
const planName = ref('')  

// NUEVO: Configuración de límites por plan
const PLAN_LIMITS = {
  1: { limit: 3, name: 'Plan Básico' },
  2: { limit: 5, name: 'Plan Plus' },
  3: { limit: 10, name: 'Plan Premium' },
  4: { limit: Infinity, name: 'Plan Enterprise' },
  5: { limit: 3, name: 'Plan Básico' },
  6: { limit: 5, name: 'Plan Plus' },
  7: { limit: 10, name: 'Plan Premium' },
  8: { limit: Infinity, name: 'Plan Enterprise' },
  9: { limit: 0, name: 'Plan Gratuito' }
};

const myPropertiesCount = ref();



const isLimitReached = computed(() => {
  console.log("esta es la cuenta: ",myPropertiesCount.value)
  return myPropertiesCount.value >= propertyLimit.value;
});

// Variable que controla si se debe bloquear por suscripción/límite
const shouldBlockBySubscription = computed(() => {
  // Bloquear si la suscripción no está activa
  if (subscriptionStatus.value !== 'active') return true;
  
  // Bloquear si el plan es 9 (gratuito)
  if (currentPlanId.value === 9) return true;
  
  // Bloquear si ya alcanzó el límite de propiedades
  if (isLimitReached.value) return true;
  
  return false;
});



// Computed properties for step validation
const stepValidations = computed(() => {
  const validation = propertyData.value || {};
  
  return {
    0: validation.fn_validation_gral || false,        // Información general
    1: validation.fn_validation_price || false,       // Precio
    2: validation.fn_validation_location || false,    // Ubicación
    3: validation.fn_validation_characters || false,  // Características
    4: validation.fn_validation_features || false,    // Detalles adicionales
    5: validation.fn_validation_images || false,      // Media
    6: validation.fn_validation_name_ia || false,     // Título
    7: validation.fn_validation_description_ia || false // Descripción
  };
});

async function checkSubscription() {
  try {
    const options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/checkActive/${session.value.id}`,
      options
    );

    const data = response.data?.original;

    if (data) {
      const status = data.status;
      const planId = data.plan_id;
      
      // Guardar información del plan
      currentPlanId.value = planId;
      
      // Establecer límite de propiedades
      if (PLAN_LIMITS[planId]) {
        propertyLimit.value = PLAN_LIMITS[planId].limit;
        planName.value = PLAN_LIMITS[planId].name;
      }

      // Validaciones de suscripción
      if (status !== 'active') {
        subscriptionStatus.value = 'expired';
        showSubscriptionModal.value = true;
        console.warn('Suscripción inactiva:', data.message);
        return;
      }

      // Segunda validación: si el plan es el gratuito (id = 9)
      if (planId === 9) {
        subscriptionStatus.value = 'expired';
        showSubscriptionModal.value = true;
        console.warn('Suscripción gratuita (no válida).');
        return;
      }

      // Si pasa ambas validaciones
      subscriptionStatus.value = 'active';
      showSubscriptionModal.value = false;
      console.log('Suscripción activa y válida');

    } else {
      // Sin datos válidos en la respuesta
      subscriptionStatus.value = 'expired';
      showSubscriptionModal.value = true;
      console.warn('No se obtuvo información válida de la suscripción');
    }

  } catch (error) {
    console.error('Error al verificar suscripción:', error);
    subscriptionStatus.value = 'expired';
    showSubscriptionModal.value = true;
  }
}

async function get_count_propierties() {
  loader.value = true;
  try {
    let url_cnn = '';
    
    url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/properties_count/${session.value.id}`;

    var options = {
      headers: {
        "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
        Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
      },
    };

    const response = await axios.get(url_cnn, options);
    if (response.status == 200) {
      console.log(response.data)
      myPropertiesCount.value = response.data.total_active_properties;
      //console.log('Propiedades encontradas',properties.value);
    }
       
    loader.value = false;
  } catch (error) {
    console.error('ERROR', error)
    loader.value = false;
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
  }
}



function handleSubscriptionConfirm() {
  showSubscriptionModal.value = false;
  router.push('/info-payments');
}

function handleSubscriptionCancel() {
  showSubscriptionModal.value = false;
  router.push('/home');
}

// Computed property para determinar el step actual basado en validaciones
const currentStepBasedOnValidations = computed(() => {
  const validations = stepValidations.value;
  
  // Si fn_validation_gral: false, mostrar step 0
  if (!validations[0]) return 0;
  
  // Si fn_validation_price: false, mostrar step 1
  if (!validations[1]) return 1;
  
  // Si fn_validation_location: false, mostrar step 2
  if (!validations[2]) return 2;
  
  // Si fn_validation_characters: false, mostrar step 3
  if (!validations[3]) return 3;
  
  // Si fn_validation_features: false, mostrar step 4
  if (!validations[4]) return 4;
  
  // Si fn_validation_images: false, mostrar step 5
  if (!validations[5]) return 5;
  
  // Si fn_validation_name_ia: false, mostrar step 6
  if (!validations[6]) return 6;
  
  // Si fn_validation_description_ia: false, mostrar step 7
  if (!validations[7]) return 7;
  
  // Si todo está completo, mantener en el último step
  return 7;
});

// Computed property para verificar si la propiedad está completa
const complete_property = computed(() => {
  const validations = stepValidations.value;
  
  // Verificar que todas las validaciones requeridas estén completas
  return validations[0] && // Información general
         validations[1] && // Precio
         validations[2] && // Ubicación
         validations[3] && // Características
         validations[5];   // Media/Gallery
});

/* Computed property para verificar si las coordenadas del mapa están disponibles
const hasMapCoordinates = computed(() => {
  if (!formLocationRef.value) return false;
  const lat = formLocationRef.value.property_lt;
  const lng = formLocationRef.value.property_ln;
  return lat && lat !== '' && lng && lng !== '';
});*/

// Computed property para verificar si la ubicación está activa (campos requeridos completos)
const isLocationActive = computed(() => {
  if (!formLocationRef.value) return false;
  return formLocationRef.value.isActiveLocation || false;
});

// Event handlers for ProgressBar component
function onProgressChange(data) {
  console.log('Progress changed:', data);
  // Aquí se puede agregar lógica personalizada cuando cambie el progreso
}

function onProgressComplete(data) {
  console.log('Progress completed:', data);
  // Aquí se puede agregar lógica cuando se complete el 100%
  // Por ejemplo: mostrar un mensaje de felicitación o redirigir
}

onMounted(async () => {
  loader.value = true;
  await checkSubscription();
  await get_count_propierties();
  if (id !== undefined) {
    active_tab.value = true;
    await getProperty();

    if (propertyData.value.partners && propertyData.value.partners.length > 0) {
      const temp = {};

      propertyData.value.partners.forEach(partner => {
        if (partner.status !== 'active') return;

        const key = partner.partner;

        if (!temp[key]) {
          temp[key] = {
            partner: key,
            sale: null,
            rent: null
          };
        }

        const type = partner.transaction_type.toLowerCase();

        // Clasificamos según tipo de transacción
        if (type === 'sale' || type === 'sale-rent') {
          if (!temp[key].sale) {
            temp[key].sale = partner.url;
          }
        } else if (type === 'rent' || type === 'rental') {
          if (!temp[key].rent) {
            temp[key].rent = partner.url;
          }
        }
      });

      // Convertir el objeto en array para iterar en template
      groupedPartners.value = Object.values(temp);
    }
  }
  loader.value = false;
});

async function updateProperty(){
  
  // Recargar los datos de la propiedad para actualizar las validaciones
  await getProperty();

}

// Navigation functions
async function nextStep() {
  // Prevenir múltiples clics
  if (isSaving.value) return;
  
  isSaving.value = true;
  
  // Guardar datos del step actual antes de avanzar
  try {
    const saveSuccess = await saveCurrentStepData();
    
    // Solo avanzar si el guardado fue exitoso
    if (saveSuccess && currentStep.value < steps.length - 1) {
      const wasStep2 = currentStep.value === 2;
      currentStep.value++;
      // Resetear mapOpened cuando avanzamos desde el step 2
      if (wasStep2) {
        mapOpened.value = false;
      }

      await getProperty();

      // Si entramos al step 6, el step 5 está validado y el step 6 NO está validado, mostrar modal PublishOrIA
      if (currentStep.value === 6 && stepValidations.value[5] && !stepValidations.value[6]) {
        showPublishOrIAModal.value = true;
        return; // No continuar con la navegación automática
      }

      // Si entramos al step 7, el step 6 está validado y el step 7 NO está validado, mostrar modal Title
      if (currentStep.value === 7 && stepValidations.value[6] && !stepValidations.value[7]) {
        showTitleModal.value = true;
        return; // No continuar con la navegación automática
      }

    } else if (!saveSuccess) {
      console.log('No se pudo guardar los datos, permaneciendo en el step actual');
    }
  } catch (error) {
    console.error('Error al guardar datos del step actual:', error);
    showToast('danger', 'Error al guardar los datos. Por favor, verifica la información e intenta de nuevo.');
  } finally {
    isSaving.value = false;
  }
}

function previousStep() {
  if (currentStep.value > 0) {
    currentStep.value--;
    // Resetear mapOpened cuando salimos del step 2
    if (currentStep.value !== 2) {
      mapOpened.value = false;
    }
  }
}

// Función helper para guardar datos del step actual
async function saveCurrentStepData() {
  let saveResult = false;
  
  switch (currentStep.value) {
    case 0: // FormGeneralComponent
      if (formGeneralRef.value && typeof formGeneralRef.value.save === 'function') {
        saveResult = await formGeneralRef.value.save();
      }
      break;
    case 1: // FormPriceComponent
      if (formPriceRef.value && typeof formPriceRef.value.save === 'function') {
        saveResult = await formPriceRef.value.save();
      }
      break;
    case 2: // FormLocationComponent
      if (formLocationRef.value && typeof formLocationRef.value.save === 'function') {
        saveResult = await formLocationRef.value.save();
      }
      break;
    case 3: // FormCharactersComponent
      if (formCharactersRef.value && typeof formCharactersRef.value.save === 'function') {
        saveResult = await formCharactersRef.value.save();
      }
      break;
    case 4: // AccordionDetailsComponent
      if (accordionDetailsRef.value && typeof accordionDetailsRef.value.save === 'function') {
        saveResult = await accordionDetailsRef.value.save();
      }
      break;
    case 5: // FormMediaComponent
      if (formMediaRef.value && typeof formMediaRef.value.save === 'function') {
        saveResult = await formMediaRef.value.save();
      }
      break;
    case 6: // FormTittle
      if (formTittleRef.value && typeof formTittleRef.value.saveTitle === 'function') {
        saveResult = await formTittleRef.value.saveTitle();
      }
      break;
    case 7: // FormDescription
      if (formDescriptionRef.value && typeof formDescriptionRef.value.saveDescription === 'function') {
        saveResult = await formDescriptionRef.value.saveDescription();
      }
      break;
  }
  
  return saveResult;
}

function navigateToStep(stepIndex) {
  // Validar que se puede navegar al step solicitado
  if (stepIndex === 0) {
    // Siempre se puede ir al primer step
    currentStep.value = stepIndex;
    // Resetear mapOpened si navegamos fuera del step 2
    if (stepIndex !== 2) {
      mapOpened.value = false;
    }
    return;
  }
  
  // Para otros steps, verificar que el step anterior esté validado
  const previousStepIndex = stepIndex - 1;
  if (stepValidations.value[previousStepIndex]) {
    currentStep.value = stepIndex;
    // Resetear mapOpened si navegamos fuera del step 2
    if (stepIndex !== 2) {
      mapOpened.value = false;
    }
  }
}

// Exit functionality
function handleExit() {
  const hasValidatedSteps = Object.values(stepValidations.value).some(Boolean);
  
  if (hasValidatedSteps) {
    showDraftModal.value = true;
  } else {
    showExitModal.value = true;
  }
}

// Modal handlers
function handleExitConfirm() {
  showExitModal.value = false;
  // Redirigir a la lista de propiedades
  window.location.href = '/properties';
}

function handleDraftConfirm() {
  showDraftModal.value = false;
  // Redirigir a la lista de propiedades (la propiedad ya se guardó automáticamente)
  window.location.href = '/properties';
}

function handleModalCancel() {
  showExitModal.value = false;
  showDraftModal.value = false;
  showPublishOrIAModal.value = false;
  showTitleModal.value = false;
}

// Handlers para PublishOrIAModal
function handlePublishFromModal() {
  showPublishOrIAModal.value = false;
  // Ejecutar la función de publicación
  changeStatus();
}

function handleOptimizeWithIA() {
  showPublishOrIAModal.value = false;
  // Continuar al siguiente step (6 - Título)
  currentStep.value = 6;
}

// Handlers para TitleModal
function handlePublishFromTitleModal() {
  showTitleModal.value = false;
  // Ejecutar la función de publicación
  changeStatus();
}

function handleOptimizeDescriptionWithIA() {
  showTitleModal.value = false;
  // Continuar al siguiente step (7 - Descripción)
  currentStep.value = 7;
}

// Event handlers para IA
async function onTitleSaved() {
  console.log('Título guardado, actualizando validaciones...');
  await getProperty();
}

async function onDescriptionSaved() {
  console.log('Descripción guardada, actualizando validaciones...');
  await getProperty();
}

// Función para abrir el modal del mapa desde el botón del padre
function handleOpenMap() {
  if (formLocationRef.value && typeof formLocationRef.value.openModalMaps === 'function') {
    formLocationRef.value.openModalMaps();
    mapOpened.value = true;
  }
}

async function getProperty() {
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${id}`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.get(url_cnn, options);
    const resp = response.data.resp;

    propertyData.value = resp; // Guardar los datos de la propiedad en propertyData
    type_movent.value = propertyData.value.general.type_movement_id;
    
    // Update is_available status
    is_available.value = resp.status && resp.status.status_id === 1;
    
    console.log(propertyData.value);
  } catch (error) {
    console.log("[ERROR]", error.response);
  }
}


async function changeStatus() {

  loader.value = true;
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${id}/change_status`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  let param_post = { status: 1 }; // Solo enviar status: 1 para activar

  try {
    const response = await axios.put(url_cnn, param_post, options);
    console.log("[STATUS UPDATED]", response.data);

    const partners = propertyData.value.partners || [];
    const easyBrokerPartner = partners.find(p => p.partner === 'EasyBroker');
    const propiedadesComPartner = partners.find(p => p.partner === 'PropiedadesCom');

    // Siempre activar: CREAR en EasyBroker si no está activo ni eliminado
    if (!easyBrokerPartner || (easyBrokerPartner.status !== 'active' && easyBrokerPartner.status !== 'delete')) {
      await syncWithEasyBroker();
    } else if (easyBrokerPartner.status === 'delete') {
      await updateWithEasyBroker();
    } else {
      console.log("✅ EasyBroker ya activo, no se hace nada.");
    }

    // PropiedadesCom
    if (!propiedadesComPartner || propiedadesComPartner.status !== 'active') {
      await syncWithPropiedades();
    } else {
      console.log("✅ PropiedadesCom ya activo, no se sincroniza.");
    }

    // Redirección garantizada después de todas las sincronizaciones
    console.log("[REDIRECTING] Redirigiendo a página de resumen...");
    window.location.href = `/properties/resume/${id}`;
    
  } catch (error) {
    console.error("[ERROR UPDATING STATUS]", error.response);
    showToast("danger", "Error al publicar la propiedad");
    loader.value = false;
  }
}

// Función para llamar a las notificaciones de remate
async function callAuctionNotifications() {
    try {
        const notificationUrl = `${process.env.VUE_APP_API_BASE_URL}/auction-notice/${id}`;
        const slackNotificationUrl = `${process.env.VUE_APP_API_BASE_URL}/slack-auction/${id}`;
        
        const options = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${session.value.token_api}`,
            },
        };

        // Llamar a la notificación de Hilos (WhatsApp)
        await axios.post(notificationUrl, {}, options);
        console.log("[AUCTION NOTICE] Notificación de Hilos enviada");
        
        // Llamar a la notificación de Slack
        await axios.post(slackNotificationUrl, {}, options);
        console.log("[AUCTION NOTICE] Notificación de Slack enviada");
        
        showToast("success", "Notificaciones de remate enviadas");
        
    } catch (error) {
        console.error("[ERROR IN AUCTION NOTIFICATIONS]", error.response);
        showToast("warning", "Notificaciones de remate no enviadas");
    }
}


//Función para sincronizar con propiedades.com
async function syncWithPropiedades() {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/properties/${id}/sync-with-propiedades`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);
    console.log("[SYNC SUCCESS]", response.data);
    showToast("success", "Propiedad sincronizada con propiedades.com");
    //setTimeout(() => {
    //  window.location.reload();
    //}, 1500); 
    
  } catch (error) {
    console.error("[ERROR SYNCING WITH PROPIEDADES.COM]", error.response);
  }
}
async function syncWithEasyBroker() {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/enviar-easybroker/${id}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("[SYNC SUCCESS]", response.data);
      showToast("success", "Propiedad sincronizada con EasyBroker");

      // Verificar si es remate (type_movent = 5) y llamar a las notificaciones
      if (type_movent.value === 5) {
        await callAuctionNotifications();
      }

      // La redirección se maneja en changeStatus()
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);
    } else {
      console.warn("[SYNC WARNING] Error en respuesta:", response.data);
    }

  } catch (error) {
    console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
    showToast("error", "Error al sincronizar con EasyBroker");
  }
}

async function updateWithEasyBroker() {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${id}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    // Validar que el código sea 200 y además el contenido indique éxito
    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("[SYNC SUCCESS]", response.data);
      showToast("success", "Propiedad sincronizada con EasyBroker");
      // La redirección se maneja en changeStatus()
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);
    } else {
      console.warn("[SYNC WARNING] Error en respuesta:", response.data);
    }

  } catch (error) {
    console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
    showToast("error", "Error al sincronizar con EasyBroker");
  }
}
/*
async function deleteFromEasyBroker() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/delete-easybroker/${id}`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, options);
    
    if (response.status === 200) {
      console.log("Propiedad eliminada en Easy Broker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      console.log("Error al eliminar en pEasy Broker", response.status);
    }
  } catch (error) {
    console.error("Error al eliminar en Easy Broker:", error);
  }
}*/

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}
async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

watch(
  () => route.params.id,
  (newId) => {
    console.log('[-----]', newId);
    id = newId;
    getProperty(); // Vuelve a cargar los datos cuando cambie el ID
  }
);

// Watcher para navegar automáticamente basado en validaciones
watch(
  currentStepBasedOnValidations,
  (newStep) => {
    // No navegar automáticamente si algún modal está visible
    if (showPublishOrIAModal.value) {
      console.log('Modal de PublishOrIA visible, no navegando automáticamente');
      return;
    }
    
    if (showTitleModal.value) {
      console.log('Modal de Title visible, no navegando automáticamente');
      return;
    }

    // No navegar automáticamente si estamos en el step 5 (Media)
    if (currentStep.value === 5) {
      console.log('En step 5 (Media), no navegando automáticamente');
      return;
    }
    
    console.log('Navegando automáticamente al step:', newStep);
    currentStep.value = newStep;
  },
  { immediate: true }
);

</script>